/**
 * Trek difficulty: dot tiers for cards + admin select (stored as plain text on trek).
 *
 * 1 dot — Easy, Easy to Moderate
 * 2 dots — Moderate+
 * 3 dots — Challenging
 */
export const TREK_DIFFICULTY_GROUPS = [
  { dots: 1, label: '1 dot', options: ['Easy', 'Easy to Moderate'] },
  { dots: 2, label: '2 dots', options: ['Moderate+'] },
  { dots: 3, label: '3 dots', options: ['Challenging'] }
];

/** Full difficulty list for admin + events sidebar (fixed order). */
export const ALL_TREK_DIFFICULTY_VALUES = TREK_DIFFICULTY_GROUPS.flatMap((g) => g.options);

/** Map legacy / Hasura labels to the current canonical set. */
export function normalizeTrekDifficultyLabel(label) {
  const raw = String(label || '').trim();
  if (!raw) return '';
  const low = raw.toLowerCase().replace(/\s+/g, ' ').trim();

  if (low === 'easy') return 'Easy';
  if (low.includes('easy to moderate') || low.includes('easy-to-moderate')) return 'Easy to Moderate';
  if (low.includes('moderate+') || low === 'moderate +') return 'Moderate+';
  if (
    low.includes('challenging') ||
    low.includes('extreme') ||
    low.includes('difficult') ||
    low.includes('hard')
  ) {
    return 'Challenging';
  }
  if (low.includes('moderate')) return 'Moderate+';

  const exact = ALL_TREK_DIFFICULTY_VALUES.find((v) => v.toLowerCase() === low);
  return exact || raw;
}

/** How many dots to fill on event cards (1–3). */
export function difficultyDotTier(label) {
  const canonical = normalizeTrekDifficultyLabel(label);
  if (!canonical) return 0;
  if (TREK_DIFFICULTY_GROUPS[0].options.includes(canonical)) return 1;
  if (TREK_DIFFICULTY_GROUPS[1].options.includes(canonical)) return 2;
  if (TREK_DIFFICULTY_GROUPS[2].options.includes(canonical)) return 3;
  return 2;
}

/** Canonical labels present in data, in Easy → Moderate+ → Challenging order. */
export function sortDifficultyLabels(labels) {
  const canonical = new Set();
  for (const label of labels || []) {
    const norm = normalizeTrekDifficultyLabel(label);
    if (norm) canonical.add(norm);
  }
  return ALL_TREK_DIFFICULTY_VALUES.filter((v) => canonical.has(v));
}

/** Sidebar / filter options from upcoming trek card rows. */
export function difficultyLabelsFromUpcomingRows(rows) {
  const raw = (rows || []).map((r) => r?.trek?.difficulty).filter(Boolean);
  return sortDifficultyLabels(raw);
}

/** Client filter: selected values are canonical labels from the sidebar. */
export function trekMatchesDifficultySelection(trekDifficulty, selectedCanonical) {
  if (!selectedCanonical?.length) return true;
  const norm = normalizeTrekDifficultyLabel(trekDifficulty);
  return norm ? selectedCanonical.includes(norm) : false;
}
